import { config } from '@/config/config';
import { ApiClient, RequestConfig } from '@/utils/api/api-client';

export const restApiClient = new ApiClient(config.restApi.url);

export async function addTokenToRequest(requestConfig: RequestConfig): Promise<RequestConfig> {
  const resolvedHeaders = {
    ...requestConfig.headers,
  };

  // if (authorization) {
  //   const existingAuthorization = requestConfig.headers?.Authorization
  //   if (!existingAuthorization) {
  //     resolvedHeaders['Authorization'] = `Bearer ${authorization.access_token}`
  //   }
  // }

  return {
    ...requestConfig,
    headers: resolvedHeaders,
  };
}

restApiClient.addRequestInterceptor(async (requestConfig) => {
  const resolved = await addTokenToRequest(requestConfig);

  return resolved;
});
